export default class TagsModel {
    public id: string = null;
    public source: string = null;
    public type: string = null;

}